up.compiler('.collapsible', (element) => {
  const $element = $(element)

  let ATTRIBUTE_NAME = 'data-collapsed'
  let $body = $element.find('.collapsible--body')

  function getCollapsed() {
    return !!$element.attr(ATTRIBUTE_NAME)
  }

  function setCollapsed(makeCollapsed) {
    if (makeCollapsed) {
      $element.attr(ATTRIBUTE_NAME, true)
    } else {
      $element.removeAttr(ATTRIBUTE_NAME)
    }
  }

  function toggle() {
    setCollapsed(!getCollapsed())
  }

  $element.on('click', '.collapsible--toggle', toggle)

})
